import type { FaireProductEntity } from "../../entity_types/product";

export const p_jqzd534uvw: FaireProductEntity = {
  token: "p_jqzd534uvw",
  type: "product",
  name: "Big Navy Striped Bow Thank You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/09d4f58dc9053c9a41545d0502a6cf2105f7a17ce773fb8e564bfd059f3f7a14.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/47c4aab5cea5eb9741f9995b0f6d5daf2e07532c99919f922eeb5a9b338531b0.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:56.295Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
